module.exports = __webpack_public_path__ + "img/search.dd21cdae.svg";